import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const topbar = document.querySelector('.top-bar');
    const topbarHeight = topbar ? topbar.offsetHeight : 0;

    const handleScroll = () => {
      setIsScrolled(window.scrollY > topbarHeight);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => (location.pathname === path ? 'active' : '');

  return (
    <nav
      className={`navbar navbar-expand-lg navbar-dark fixed-top py-lg-0 px-lg-5 ${
        isScrolled ? 'bg-darks' : ''
      }`}
      style={{ transition: '0.5s' }}
    >
      {/* Logo Brand */}
      <Link to="/" className="navbar-brand d-flex align-items-center ms-1 ms-lg-0">
        <img
          src='/img/img5-Photoroom.png'
          alt="New Galaxy Interiors Logo"
          className="navbar-logo"
        />
      </Link>

      <button
        type="button"
        className="navbar-toggler me-4"
        data-bs-toggle="collapse"
        data-bs-target="#navbarCollapse"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbarCollapse">
        <div className="navbar-nav mx-auto p-4 p-lg-0">
          <Link to="/" className={`nav-item nav-link ${isActive('/')}`}>Home</Link>
          <Link to="/about" className={`nav-item nav-link ${isActive('/about')}`}>About</Link>
          <Link to="/service" className={`nav-item nav-link ${isActive('/service')}`}>Services</Link>
          <Link to="/product" className={`nav-item nav-link ${isActive('/product')}`}>Projects</Link>

          {/* <div className="nav-item dropdown">
            <a
              href="#"
              className={`nav-link dropdown-toggle ${
                location.pathname.startsWith('/team') ||
                location.pathname.startsWith('/testimonial')
                  ? 'active'
                  : ''
              }`}
              data-bs-toggle="dropdown"
            >
              Pages
            </a>
            <div className="dropdown-menu m-0">
              <Link to="/team" className="dropdown-item">Our Team</Link>
              <Link to="/testimonial" className="dropdown-item">Testimonials</Link>
              <Link to="/404" className="dropdown-item">404 Page</Link>
            </div>
          </div> */}

          <Link to="/contact" className={`nav-item nav-link ${isActive('/contact')}`}>
            Contact
          </Link>
        </div>

        {/* Contact */}
        <div className="d-none d-lg-flex align-items-center">
          <div className="flex-shrink-0 btn-lg-square border border-light rounded-circle">
            <i className="fa fa-phone text-primarys"></i>
          </div>
          <div className="ps-3">
            <small className="text-primarys mb-0">Call Us</small>
            <p className="text-light fs-5 mb-0">+971 563252389</p>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;





